import { ConvexReactClient } from "convex/react";

const url = import.meta.env.VITE_CONVEX_URL;
if (!url) {
  throw new Error(
    "Missing VITE_CONVEX_URL. Run `bunx convex dev` once to provision a deployment and write the env vars to .env.local.",
  );
}

export const convex = new ConvexReactClient(url, {
  expectAuth: true,
});

let open: ConvexReactClient | null = null;

/**
 * A client for the pages open to anyone, signed in or not (a shared room's
 * walk). `convex` holds every query until someone signs in, which a visitor
 * never does; this one asks as nobody, from its first query. Made on first use,
 * so the other pages open no second connection.
 */
export function openConvex() {
  open ??= new ConvexReactClient(url);
  return open;
}
